export const DISTROS_ROLLOUT = 'distros';
export const APPS_ROLLOUT = 'apps';
export const CM4G_ROLLOUT = 'cm4gs';
export const BUNDLES_ROLLOUT = 'bundles';

